<ng-container>
  <div *ngIf="!isArrayValues">
    <span>{{ getLabelValue(config) || config.value }}</span>
  </div>
  <div *ngIf="isArrayValues">
    <div *ngFor="let data of config.value">
      <ng-container *ngIf="isObject(data.value); else simpleValueTemplate">
        <span>{{ getLocalizedValue(data?.value )}}</span>
      </ng-container>
      <ng-template #simpleValueTemplate>
        <span>{{ data.value }}</span>
      </ng-template>
    </div>
  </div>
</ng-container>